import React from 'react';
import { Select } from 'antd';
import Field from '../../../../shared/ui/Field';
import {
  registrationStateTypes,
  useRegistrationControllers,
  useRegistrationSubscribe,
} from '../../../../services/acceptanceRegistration';
import FetchDataWrapper from '../../../../../../components/FetchDataWrapper';
import { formatPhoneNumber } from '../../../../../../helpers/formatPhoneNumber';
import { useAddOwnerSelectProps } from '../AddRegistrationOwner';

const PHONE_FORMAT = {
  format: '(xxx) xxx-xx-xx',
  placeholder: 'x',
};

const formatClientPhone = (phone) =>
  phone ? formatPhoneNumber({ phoneNumber: phone, ...PHONE_FORMAT }) : '';

const emptyArr = [];

const SelectOwner = () => {
  const ownersState = useRegistrationSubscribe({
    type: registrationStateTypes.owners,
  });

  return (
    <FetchDataWrapper
      data={ownersState.value}
      isFetching={ownersState.status === 'loading'}
      refetch={ownersState.refetch}
      errMsg={ownersState.message}
      ignoreEmpty
    >
      <SelectOwnerBase
        clients={
          Array.isArray(ownersState.value) ? ownersState.value : emptyArr
        }
      />
    </FetchDataWrapper>
  );
};

export default SelectOwner;

function SelectOwnerBase({ clients }) {
  const owner = useRegistrationSubscribe({
    type: registrationStateTypes.selectedOwner,
    selector: (state) => state.value,
  });

  const { selectOwner } = useRegistrationControllers();
  const addOwnerSelectProps = useAddOwnerSelectProps();

  const handleChange = (_, option) => {
    selectOwner(option?.props?.data);
  };

  const mustOwnerValidate = owner != null && Array.isArray(clients);

  const ownerIsValid = mustOwnerValidate
    ? clients.some((client) => client.id === owner.id)
    : true;

  const errorMessage = !ownerIsValid
    ? `Записанный собственник ${owner.name} не найден среди собственников данного адреса`
    : undefined;

  return (
    <Field.Memoized
      {...addOwnerSelectProps}
      type={Field.types.select}
      value={clients ? owner?.id : undefined}
      onChange={handleChange}
      formItemLabel="Собственник"
      required
      style={{ width: '100%' }}
      optionFilterProp="search"
      showSearch={clients?.length > 10}
      errorMessage={errorMessage}
    >
      {clients?.map((client) => (
        <Select.Option
          key={client.id}
          value={client.id}
          search={client.name}
          data={client}
        >
          {`${client.name} ${formatClientPhone(client.phone)}`}
        </Select.Option>
      ))}
    </Field.Memoized>
  );
}
